import { StyledComponent } from '@emotion/styled';
import { BoxProps, Components as Comp, Theme, styled } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';
import { UploadProps } from '../../../types/file';

declare module '@mui/material/styles' {
  interface Components {
    MuiUploadField?: {
      defaultProps?: UploadProps;
      styleOverrides?: Partial<OverridesStyleRules<'root', 'MuiUploadField', Theme>>;
    };
  }
}

export const UploadField: StyledComponent<BoxProps> = styled('div', {
  name: 'MuiUploadField',
  overridesResolver: (_props, styles) => {
    return [styles.root];
  },
})({});

export const MuiUploadField: Comp<Omit<Theme, 'components'>> = {
  MuiUploadField: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .uploadField-dashed': {
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(4),
          borderRadius: 'var(--mui-shape-borderRadius)',
          border: '2px dashed var(--mui-palette-divider)',
          [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
          },
          '&:focus': {
            outline: 'none',
          },
          '&:hover': {
            borderColor: theme.palette.common.black,
          },
          '&.uploadField-DragActive': {
            borderColor: theme.palette.info.main,
          },
          '&.uploadField-disabled': {
            opacity: 0.48,
            pointerEvents: 'none',
          },
          '&.uploadField-error': {
            color: 'error.main',
            bgcolor: 'error.lighter',
            borderColor: theme.palette.error.main,
          },
        },
        '& .uploadField-outlined': {
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          justifyContent: 'center',
          padding: theme.spacing(4),
          borderRadius: '8px',
          border: `1px solid ${theme.palette.iceGray[400]}`,
          [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
          },
          '&:focus': {
            outline: 'none',
          },
          '&:hover': {
            borderColor: theme.palette.common.black,
          },
          '&.uploadField-DragActive': {
            borderColor: theme.palette.info.main,
          },
          '&.uploadField-disabled': {
            opacity: 0.48,
            pointerEvents: 'none',
          },
          '&.uploadField-error': {
            color: 'error.main',
            bgcolor: 'error.lighter',
            borderColor: theme.palette.error.main,
          },
        },
        '& .placeholder-icon': {
          backgroundColor: 'var(--mui-palette-Avatar-defaultBg)',
          borderRadius: 'var(--mui-shape-borderRadius)',
          padding: theme.spacing(4),
          marginBottom: `${theme.spacing(9)} !important`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .file-preview': {
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
          width: '100%',
          height: '100%',
          borderRadius: 'var(--mui-shape-borderRadius)',
          padding: theme.spacing(2.5, 2.4, 2.5, 6),
          border: '1px solid var(--mui-palette-divider)',
          '& .file-preview-img': {
            width: 42,
            height: 42,
            objectFit: 'cover',
            padding: theme.spacing(0.75),
            borderRadius: 'var(--mui-shape-borderRadius)',
            border: '1px solid var(--mui-palette-divider)',
          },
        },
      }),
    },
  },
};
